import React from 'react';
import BratGenerator from './components/BratGenerator';
import './styles/global.css';

const App: React.FC = () => {
  return (
    <div className="App">
      <BratGenerator />
    </div>
  );
};

export default App;